export default __webpack_public_path__ + "static/Metropolis-ExtraLight-e8f0d427aff308b5dd508c5d54734c87.woff2";